import { inject, Injectable } from '@angular/core';
import { Messaging } from '@angular/fire/messaging';
import { getToken, isSupported, MessagePayload, onMessage } from 'firebase/messaging';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class FirebaseService {
  private readonly messaging = inject(Messaging, { optional: true });
  messageSource = new BehaviorSubject<MessagePayload | null>(null);
  foregroundMessage$ = this.messageSource.asObservable();

  constructor() {
    void this.initializeMessaging();
  }

  private async initializeMessaging(): Promise<void> {
    if (!this.messaging) {
      return;
    }

    const messagingSupported = await isSupported().catch(() => false);
    if (!messagingSupported) {
      return;
    }

    this.listenToForegroundMessages();
  }

  private listenToForegroundMessages(): void {
    if (!this.messaging) {
      return;
    }

    onMessage(this.messaging, (payload) => {
      console.log(payload, 'payload of the message')
      this.messageSource.next(payload);
    });
  }

  async requestPermissionAndGetToken(): Promise<string | null> {
    try {
      const isPermissionGranted = await this.getNotificationPermission();

      if (!isPermissionGranted) {
        return null;
      }

      return await this.getFCMToken();
    } catch {
      return null;
    }
  }

  async getFCMToken(): Promise<string | null> {
    if (!this.messaging) {
      return null;
    }

    const messagingSupported = await isSupported().catch(() => false);
    if (!messagingSupported) {
      return null;
    }

    const token = await getToken(this.messaging, {
      vapidKey: environment.firebaseVapidKey
    });

    return token ?? null;
  }

  async getNotificationPermission(): Promise<boolean> {
    if (typeof Notification === 'undefined') {
      return false;
    }

    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }
}
